// extracted by mini-css-extract-plugin
module.exports = {"badge":"oQ","isRental":"oR","badgeWrapper":"oS","hide":"oT","roundedBadge":"oU","gridBadge":"oV","darkBackground":"oW"};